const styles = (theme) => ({
	subtitulo: {
		color: theme.palette.text.secondary,
		marginBottom: "12px",
	},
	loadingContainer: {
		display: "flex",
		justifyContent: "center",
		padding: "24px",
	},
	buscaField: {
		width: "260px",
		marginBottom: "12px",
		"@media (max-width: 600px)": {
			width: "100%",
		},
	},
	paper: {
		width: "100%",
		backgroundColor: theme.palette.background.paper,
		borderRadius: "4px",
		overflow: "hidden",
	},
	gridContainer: {
		width: "100%",
		height: "320px",
		overflow: "auto",
	},
	// Fundo/texto sempre fixos (high) - indicador de bloqueio, nunca depende de qual cliente e
	chipBloqueado: {
		fontWeight: 600,
		height: "20px",
	},
	confirmacaoContainer: {
		marginTop: "16px",
	},
	erro: {
		color: theme.palette.chip.colorText.critical,
		marginTop: "12px",
	},
	resultadoContainer: {
		display: "flex",
		flexDirection: "column",
		gap: 1,
	},
	linhaResultado: {
		display: "flex",
		alignItems: "center",
		flexWrap: "wrap",
		gap: 1,
		padding: "8px 0px",
		borderTop: `1px solid ${theme.palette.divider}`,
	},
	nomeResultado: {
		minWidth: "160px",
		fontWeight: 500,
		color: theme.palette.text.primary,
	},
	chip: {
		fontWeight: 600,
		height: "20px",
	},
	motivoResultado: {
		color: theme.palette.chip.colorText.critical,
		flexBasis: "100%",
	},
	semItens: {
		color: theme.palette.text.secondary,
	},
});

export default styles;
